import React from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { AdministrationAccessProvider } from './contexts/AdministrationAccessContext';
import AppRouter from './AppRouter';
import LoginPage from './components/auth/LoginPage';
import './App.css';

const AuthGate = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1a1a2e' }}>
        <div style={{ color: '#ffffff', fontSize: '16px' }}>Cargando...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <AdministrationAccessProvider>
      <AppRouter />
    </AdministrationAccessProvider>
  );
};

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <AuthGate />
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
